export const scrollToElement = (id) => {
  if (id) {
    const releventDiv = document.getElementById(id);
    releventDiv.scrollIntoView({ behavior: "smooth" });
  }
};
